import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2942efda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stars" }
const _hoisted_2 = ["src", "height", "width"]
const _hoisted_3 = ["src", "height", "width"]
const _hoisted_4 = ["src", "height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filledStarCount, (i) => {
      return (_openBlock(), _createElementBlock("img", {
        src: _ctx.filledStarImageSrc,
        height: _ctx.size,
        width: _ctx.size,
        key: 'filled-' + i
      }, null, 8, _hoisted_2))
    }), 128)),
    _createTextVNode(),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filledStarHalfCount, (i) => {
      return (_openBlock(), _createElementBlock("img", {
        src: _ctx.filledStarHalfImageSrc,
        height: _ctx.size,
        width: _ctx.size,
        key: 'half-' + i
      }, null, 8, _hoisted_3))
    }), 128)),
    _createTextVNode(),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filledStarGrayCount, (i) => {
      return (_openBlock(), _createElementBlock("img", {
        src: _ctx.filledStarGrayImageSrc,
        height: _ctx.size,
        width: _ctx.size,
        key: 'gray-' + i
      }, null, 8, _hoisted_4))
    }), 128))
  ]))
}